export default __webpack_public_path__ + "src/images/hotspot_slide-b4dc4a.png";